import {NuxtRuntimeConfig} from '@nuxt/types/config/runtime';

  export const formatAbsoluteUrlToLocal = ((url: string, config: NuxtRuntimeConfig) => {
    return url
      .replace(/^[a-zA-Z]{3,5}\:\/{2}[a-zA-Z0-9_.:-]+\//, '')
      .replace(`${config.websiteCode}`, '');
  }
);
